import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useEffect, useState } from "react";
import axios from "axios";
import { SERVER_URL } from "constants/constant";

function Dashboard() {
  const [data, setData] = useState({
    indianDelegates: 0,
    foreignDelegates: 0,
    maleCount: 0,
    femaleCount: 0,
    salutations: {},
    vegCount: 0,
    nonVegCount: 0,
    jainCount: 0,
  });



  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/dashboard/statistics`);
        const apiData = res.data;

        const transformedData = {
          indianDelegates: apiData?.indianForeignStats?.find(stat => stat?.category === "Indian_Delegate")?.count || 0,
          foreignDelegates: apiData?.indianForeignStats?.find(stat => stat?.category === "Foreign_Delegate")?.count || 0,
          maleCount: apiData?.genderStats?.find(stat => stat?.gender === "Male")?.count || 0,
          femaleCount: apiData?.genderStats?.find(stat => stat?.gender === "Female")?.count || 0,
          salutations: Object.fromEntries(apiData?.salutationStats?.map(stat => [stat?.salutation, stat?.count]) || []),
          vegCount: apiData?.foodCategoryStats?.find(stat => stat?.foodCategory === "Vegetarian")?.count || 0,
          nonVegCount: apiData?.foodCategoryStats?.find(stat => stat?.foodCategory === "Non-Vegetarian")?.count || 0,
          jainCount: apiData?.foodCategoryStats?.find(stat => stat?.foodCategory === "Jain")?.count || 0,
          totalAdditionalMembers: apiData?.indianForeignStats?.find(stat => stat?.category === "Additional Members")?.count || 0
        };

        setData(transformedData);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    })();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <p>Overall Statistics</p>
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="groups"
                title="All"
                count={Number(data?.femaleCount) + Number(data?.maleCount) + Number(data?.othersCount || 0)}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="groups"
                title="Indian Delegates"
                count={Number(data?.femaleCount) + Number(data?.maleCount) + Number(data?.othersCount || 0) - Number(data?.foreignDelegates)}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="public"
                title="Foreign Delegates"
                count={data?.foreignDelegates}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="secondary"
                icon="man"
                title="Male"
                count={data?.maleCount}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="woman"
                title="Female"
                count={data?.femaleCount}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="secondary"
                icon="groups"
                title="Accompanying Persons"
                count={data?.totalAdditionalMembers}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>

        </Grid>
      </MDBox>
      <p>Salutations</p>
      <MDBox py={3}>
        <Grid container spacing={3}>
          {Object.entries(data?.salutations || {}).map(([key, value]) => (
            <Grid item xs={12} md={6} lg={3} key={key}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="badge"
                  title={key}
                  count={value}
                  percentage={{ color: "success", amount: "", label: "Updated" }}
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <p>Dietary Preferences</p>
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="eco"
                title="Vegetarian"
                count={data?.vegCount}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="restaurant"
                title="Non-Vegetarian"
                count={data?.nonVegCount}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="spa"
                title="Jain"
                count={data?.jainCount}
                percentage={{ color: "success", amount: "", label: "Updated" }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
